import { Box, Grid, Skeleton } from '@mui/material'
import version from "../../../../package.json";

const ProfileSkeleton = () => {
    return (
        <Grid container flexDirection={"column"} height={"calc(100svh - 120px)"} sx={{ position: "relative" }}>
            <Grid item height={"20%"} sx={{ zIndex: 10, background: 'var(--header-color)', position: "relative" }}></Grid>
            <Grid item height={"100%"} sx={{ width: "100%", top: '8vh', position: "absolute", display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                <Box>
                    <Box>
                        <Skeleton width={"100%"} height={150} sx={{ transform: "unset" }} />
                    </Box>
                    <Box sx={{ paddingInline: "20px", marginTop: "20px", maxHeight: "calc(100svh - 60%)", height: "100%", overflowY: "auto" }}>
                        {[...Array(5)].map((_, index) => (
                            <Skeleton key={index} width={"100%"} height={70} sx={{ marginTop: "10px", transform: "unset" }} />
                        ))}
                    </Box>
                </Box>
                <Box sx={{ position: "fixed", bottom: 55, width: "fit-content", left: "30px" }}>
                    <div style={{ color: "#716e6e7a", width: "100%", textAlign: "center", opacity: "0.85" }}>
                        v {version.version}
                    </div>
                </Box>
            </Grid>
        </Grid>
    )
}

export default ProfileSkeleton